@use "~theme/breakpoints";
@use "~theme/typography";

.container {
  padding: 24px 24px 40px;

  @include breakpoints.desktop {
    padding: 32px 40px 40px;
  }
}

.card {
  position: relative;
  display: grid;
  gap: 24px;
  border: 1px solid var(--blue-01-at-30);
  padding: 16px 28px;
  border-radius: 4px;
  background-color: var(--blue-03-at-30);

  @include breakpoints.desktop {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-auto-flow: column;
  }
}

.edit {
  position: absolute;
  top: 16px;
  right: 100px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: right;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: var(--blue-01-at-30);
}

.editSingle {
  position: absolute;
  top: 16px;
  right: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: right;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: var(--blue-01-at-30);
}

.remove {
  position: absolute;
  top: 16px;
  right: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: right;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: var(--blue-01-at-30);
}
